import styled from 'styled-components';
import { SingleSelect } from 'ui-components/src/components/atoms/Select/Single';

export const StyledSelect = styled(SingleSelect)`
  margin-top: 16px;

  ul {
    top: 45px;
  }
`;
